import {useContext} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/PlayerTrendTeamFilter.css"

function PlayerTrendTeamFilter({sortedTrends, onSelect, selectedTeam}) {
    const {state} = useContext(UserContext);

    const allTeams = [...new Set(sortedTrends.map((trend) => trend.team))].sort()

    const columnCount = Math.ceil(allTeams.length/2)

    return (
        <div className="buttonsContainer">
            <div className="team-grid dynamic-columns" style={{ "--column-count": columnCount }}>  
                <label>Filter by Team: </label>
                <button className="filterButton" style={{backgroundColor: selectedTeam === null ? "#cbd5e1" : "transparent", color: selectedTeam === null ? "black" : "white", marginRight: "0.15rem"}} onClick={() => onSelect(null)} id="allTeams">All Teams</button>
                {allTeams.map((team) => {
                    return (
                        <button className="filterButton" style={{backgroundColor: selectedTeam === team ? state.teamColors[team].primary : "transparent", marginRight: "0.15rem"}} key={team} onClick={() => onSelect(team)}>{team}</button>
                    )
                })}
            </div>
            <p>Note: If a player is missing, they don't meet the minimum number of games for their rating. Click on their name from the ratings or single game table to see their trends.</p>
        </div>
    )
}

export default PlayerTrendTeamFilter